<template>
  <div v-if="!isDeleted">
    <div>
      <div class="view-comment">
        <div class="view-comment__avatar" :class="{owner: isOwner, primary: isPrimary && !isOwner}">
          <user-avatar :user="comment.user" />
        </div>
        <article class="view-comment__content" :class="{owner: isOwner}">
          <span class="user-name">{{comment.user.name}}</span>
          {{' ' }}{{comment.description}}
        </article>
      </div>
      <footer>
        <inline-list withPadding withMargin class="view-comment__meta">
          <li>
            <date :date="comment.created_time" :relative="true" />
          </li>
          <li v-if="questionOpen">
            <base-button asLink @click="handleReply">
              <span>Reply</span>
            </base-button>
          </li>
          <li v-if="userCanDelete">
            <base-button asLink @click="$emit('delete',comment);">
              <span>Delete</span>
            </base-button>
          </li>
          <li>
            <a :href="commentLink" @click.prevent="copyCommentLink(commentLink)">Link</a>
          </li>
        </inline-list>
      </footer>
    </div>
  </div>
</template>

<script>
import { TextArea } from "@/components/forms";
import BaseButton from "@/components/BaseButton";
import { InlineList } from "@/components/Lists";
import { Date } from "@/components/elements";
import { mapState } from "vuex";
import UserHasPermission from "@/mixins/UserHasPermission";
const UserAvatar = () => import("@/components/UserAvatar");
export default {
  name: "ViewComment",
  methods: {
    handleSubmit() {
      this.$emit("submit");
    },
    handleReply() {
      this.$emit("reply", this.comment.id);
    },
    copyCommentLink(text) {
      const vm = this;
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function() {
          vm.$store.dispatch("notifications/create", {
            body: "Link has been copied to your clipboard",
            type: "success"
          });
        },
        function(err) {
          vm.$store.dispatch("notifications/create", {
            body: `Could not copy link - ${err}`,
            type: "error"
          });
        }
      );
    },
    fallbackCopyTextToClipboard(text) {
      const vm = this;
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        if (successful) {
          vm.$store.dispatch("notifications/create", {
            body: "Link has been copied to your clipboard",
            type: "success"
          });
        } else {
          vm.$store.dispatch("notifications/create", {
            body: `Could not copy link - ${err}`,
            type: "error"
          });
        }
      } catch (err) {
        vm.$store.dispatch("notifications/create", {
          body: `Could not copy link - ${err}`,
          type: "error"
        });
      }

      document.body.removeChild(textArea);
    }
  },

  mixins: [UserHasPermission],
  props: {
    comment: Object,
    questionOpen: {
      type: Boolean,
      default: true
    }
  },
  components: {
    TextArea,
    InlineList,
    Date,
    UserAvatar
  },

  data() {
    return {
      isDeleted: false
    };
  },
  computed: {
    userCanDelete() {
      if (
        this.$store.state.Questions.question.created_user.id ==
        this.$store.state.auth.currentUser.id
      ) {
        return true;
      }
      return this.isInGroup("collaboration_manager");
    },
    commentLink() {
      const { protocol, host } = window.location;
      return `${protocol}//${host}/collaboration/question/${
        this.$route.params.questionId
      }/idea/${this.$route.params.ideaId}#comment_${this.comment.id}`;
    },
    isOwner() {
      //this is the person who wrote the question, should be orange
      return (
        this.$store.state.Questions.question.created_user.id ===
        this.comment.created_user.id
      );
    },
    isPrimary() {
      // this is the person who created the idea, should be blue
      return (
        this.$store.state.Ideas.idea.user.id === this.comment.created_user.id
      );
    }
  }
};
</script>

<style lang="scss">
.view-comment {
  &__avatar {
    width: 10%;
    max-width: 51px;
    display: inline-block;
    border-radius: 100%;
    margin-right: 5%;
    width: 41px;
    max-height: 41px;

    @media (min-width: 768px) {
      width: 51px;
      max-height: 51px;
    }
    img {
    }

    &.owner {
      // img {
      border: 3px solid $colour-nhs-core-blue;
      box-sizing: border-box;

      // }
    }

    &.primary {
      // img {
      border: 3px solid $colour-nhs-orange;
      box-sizing: border-box;
      // }
    }
  }
}
</style>

<style scoped lang="scss">
.view-comment {
  display: flex;

  &__content {
    width: 85%;
    white-space: pre-line;
    font-size: 14px;
    line-height: 20px;

    &.owner {
      border-radius: 18px;
      background: #f3f6f6;
      border: 1px solid $colour-nhs-pale-grey;
      padding: 10px;

      box-sizing: border-box;
    }
  }

  &__meta {
    font-size: 14px;

    li:nth-child(1) {
      display: block;
      width: 100%;

      @media (min-width: 768px) {
        display: inline-block;
        width: auto;
      }
    }
  }
}

footer {
  margin-top: 1em;

  margin-left: calc(5% + 41px);

  @media (min-width: 768px) {
    margin-left: calc(5% + 51px);
  }
}

.user-name {
  color: $colour-nhs-core-blue;
  font-weight: bold;
}

.c-button {
  font-size: 14px;
}

a {
  text-decoration: none;
}
</style>